import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { einvoicingApiClient, normalizeApiError } from '../../../api/client/axios';
import { showSnackbar } from '../../../store/snackbarSlice';

export const provisionTIN = async ({ orgId, tin, email, business_name, vat_number }) => {
  const { data } = await einvoicingApiClient.post('/api/tins/provision', {
    org_id: orgId,
    tin,
    email,
    party_name: business_name,
    tax_identifier: vat_number?.trim() || undefined,
  });
  return data;
};

export const useProvisionTINHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: provisionTIN,
    onSuccess: (data) => {
      dispatch(
        showSnackbar({
          message: `TIN ${data?.tin || ''} provisioned.`,
        }),
      );
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      onSuccess && onSuccess(data);
    },
    onError: (error) => {
      const { message } = normalizeApiError(error);
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    onSubmit: mutation.mutate,
    isPending: mutation.isPending,
  };
};
